export const availableOrganizationsKeys = {
  all: ['available-organizations'],
  lists: () => [...availableOrganizationsKeys.all, 'list'],
  list: () => [...availableOrganizationsKeys.lists()],
} as const;
